import { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { AI_ASSISTANT_BLUE } from "../constants";

export default function QuizSuccessCard({ quiz, onOpenDetails, onOpenResults }) {
  const [copied, setCopied] = useState(false);
  if (!quiz) return null;

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(String(quiz.access_code || ""));
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      // ignore
    }
  };

  return (
    <Box
      sx={{
        mx: 2,
        mb: 1.5,
        p: 1.6,
        borderRadius: 2.5,
        border: "1px solid rgba(16, 185, 129, 0.35)",
        bgcolor: "#f0fdf4",
      }}
    >
      <Typography sx={{ fontSize: 12, fontWeight: 800, color: "#059669", letterSpacing: 0.6 }}>
        QUIZ CREATED
      </Typography>
      <Typography fontWeight={700} sx={{ mt: 0.4, color: "#0f172a" }}>
        {quiz.title}
      </Typography>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
        <Typography variant="body2" sx={{ color: "#334155" }}>
          Code: <strong>{quiz.access_code}</strong>
        </Typography>
        <Button
          size="small"
          startIcon={copied ? <CheckRoundedIcon /> : <ContentCopyRoundedIcon />}
          onClick={copyCode}
          sx={{ textTransform: "none", color: AI_ASSISTANT_BLUE }}
        >
          {copied ? "Copied" : "Copy Quiz Code"}
        </Button>
      </Stack>
      <Stack direction="row" spacing={1} sx={{ mt: 1.4 }}>
        <Button
          size="small"
          variant="contained"
          disableElevation
          onClick={onOpenDetails}
          sx={{
            textTransform: "none",
            fontWeight: 700,
            color: "#ffffff !important",
            bgcolor: `${AI_ASSISTANT_BLUE} !important`,
            "&:hover": {
              color: "#ffffff !important",
              bgcolor: "#0052d6 !important",
            },
          }}
        >
          Open quiz
        </Button>
        {typeof onOpenResults === "function" ? (
          <Button
            size="small"
            variant="outlined"
            onClick={onOpenResults}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              color: `${AI_ASSISTANT_BLUE} !important`,
              borderColor: `${AI_ASSISTANT_BLUE} !important`,
              bgcolor: "#ffffff !important",
              "&:hover": {
                color: "#0052d6 !important",
                borderColor: "#0052d6 !important",
                bgcolor: "rgba(0, 97, 254, 0.06) !important",
              },
            }}
          >
            Results
          </Button>
        ) : null}
      </Stack>
    </Box>
  );
}

QuizSuccessCard.propTypes = {
  quiz: PropTypes.object,
  onOpenDetails: PropTypes.func.isRequired,
  onOpenResults: PropTypes.func,
};
